module.exports = __webpack_public_path__ + "static/media/anniston-d.100bbb53.jpg";